<nav class="navbar navbar-expand">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-8">
                <div class="navbar-brand d-flex align-items-center" (click)="navigateHome()" (keydown)="onKeyDown($event)">
                    <img src="{{ logo }}" alt="Logo" class="align-text-top brand-logo" />
                    <span class="brand-text">Claim Respondent Gateway</span>
                </div>
                <div class="navbar-nav">
                    <div>{{ account?.name }}</div>
                </div>
            </div>
        </div>
    </div>
</nav>
